import { render } from "./DemoTerms.vue?vue&type=template&id=51359593"
import script from "./DemoTerms.vue?vue&type=script&lang=js"
export * from "./DemoTerms.vue?vue&type=script&lang=js"

import "./DemoTerms.vue?vue&type=style&index=0&id=51359593&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__